export const SET_PROFILE_ID = 'SET_PROFILE_ID'
export const SET_FAMILY_CRUD_ACTION = 'SET_FAMILY_CRUD_ACTION'

export function setProfileId(profileId) {
  return { type: SET_PROFILE_ID, profileId }
}

export function setFamilyCrudAction(crudAction) {
  return { type: SET_FAMILY_CRUD_ACTION, crudAction }
}
